import { TimePeriodUnit } from '@modules/common/components/DateRangePicker/types';
import { TimeUnit } from 'generated/graphql';

export const mapToEdgeTimeUnit = (TimePeriod: TimePeriodUnit): TimeUnit => {
  switch (TimePeriod) {
    case TimePeriodUnit.Day:
      return TimeUnit.Day;
    case TimePeriodUnit.Week:
      return TimeUnit.Week;
    case TimePeriodUnit.Month:
      return TimeUnit.Month;
  }
};
